import makeStyles from "@mui/styles/makeStyles";
import portalSettingsManager from "utils/portalSettingsManager";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& .k-datepicker": {
      border: "1px solid rgba(0,0,0,0.54)",
      backgroundColor: "#ffffff",
      height: "34.5px",
      borderRadius: "2px",
    },
    "& .k-picker-wrap": {
      border: "0px solid black",
    },
    "& .k-input": {
      fontSize: "14px",
      lineHeight: "100%",
      marginLeft: "1px",
    },

    "& .k-icon": {
      fontSize: "14px",
      color: portalSettingsManager.buttonColors?.dark?.active?.text,
    },
    "& .k-dateinput-wrap.k-state-focused": {
      border: "2px solid #000 !important",
    },
    "& .k-textbox-container": {
      width: "50%",
    },
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    "@media (max-width:900px)": {
      gap: "40px",
      flexDirection: "column",
    },
    paddingBottom: "20px",
  },
  calendarPopup: {
    zIndex: "99999 !important",
    "& .k-calendar": {
      backgroundColor: "#ffffff",
      borderRadius: "0px",
      border: "1px solid !important",
    },
    "& .k-calendar-nav-today>.k-button-text": {
      color: portalSettingsManager.buttonColors?.themed?.active?.text,
    },
    "& .k-calendar .k-calendar-title": {
      color: portalSettingsManager.buttonColors?.themed?.active?.text,
    },
    "& .k-calendar .k-calendar-td.k-selected .k-link": {
      backgroundColor: portalSettingsManager.buttonColors?.themed?.active?.text,
    },
    "& .k-calendar-td.k-state-pending-focus": {
      color: "rgba(0, 0, 0, 0.87) !important",
      border: "2px solid black !important",
      backgroundColor: "#f7f7f7 !important",
    },
  },
  filterElement: {
    width: "100%",
    "@media (max-width:900px)": {
      width: "100% !important",
    },
  },
  filterLabel: {
    fontSize: "14px",
    color: theme.palette.grey["500"],
    fontWeight: 600,
    paddingRight: "20px",
    "@media (max-width:900px)": {
      width: "70px",
      display: "inline-block",
      paddingRight: "0px",
    },
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
  filterButton: {
    padding: "5px 20px",
    color: portalSettingsManager.buttonColors?.dark?.active?.text,
    backgroundColor: portalSettingsManager.application?.common?.themeColor,
    border: "1px",
    height: "34.5px",
    cursor: "pointer",
    "&:hover": {
      color: `${portalSettingsManager?.buttonColors?.themed?.active?.text} !important`,
      border: `2px solid ${portalSettingsManager?.buttonColors?.themed?.hover?.border}`,
    },
    "&.Mui-focusVisible": {
      color: `${portalSettingsManager.buttonColors?.themed?.active?.text} !important`,
      border: `2px solid ${portalSettingsManager?.buttonColors?.themed?.hover?.border}`,
      backgroundColor: `${portalSettingsManager.buttonColors?.normal?.hover?.back} !important`,
    },
    "&.Mui-disabled": {
      color: theme.palette.grey["900"],
      backgroundColor: theme.palette.grey["300"],
      border: `1px solid ${theme.palette.grey["900"]}`,
    },
  },
  filtersAndActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "24px", // even spacing between filters
    width: "100%",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "20px",
    },
  },
  calendarIcon: {
    margin: "4px 4px",
    fontSize: "18px",
  },
  filterElementDiv: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  filterCheckbox: {
    marginRight: 8,
    padding: 0,
  },
  dropdownDiv: {
    flexBasis: "50%",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  dropDownListBox: {
    maxHeight: 300,
    marginTop: 4,
  },
  inlineLabelWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px", // or more depending on visual spacing
    width: "100%",
  },
  buttonContainer: {
    display: "flex",
    gap: "16px", // spacing between Apply and Reset buttons
    alignItems: "center",
    justifyContent: "flex-end",
    height: "100%", // vertically align with filters
    "@media (max-width:900px)": {
      justifyContent: "flex-start",
    },
  },
  autoComplete: {
    width: "100%",
  },
  filterPlaceholder: {
    "& input::placeholder": {
      color: "#000", // make it darker
      opacity: 1, // override default 0.42
      fontWeight: 500,
    },
  },
}));
